import styled from "styled-components";

export default styled.div`
    & button:nth-child(2) {
        margin-top: 10px;
    }
`;
